import { STEP_AGREEMENT_KEH } from './constants';

export const forms = [STEP_AGREEMENT_KEH];
export const steps = [STEP_AGREEMENT_KEH];
